import gql from 'graphql-tag';

export const ADD_COMMENT = gql`
  mutation AddComment($input: AddCommentInput!) {
    addComment(input: $input)
  }
`;
